import axios from 'axios'

const prefix = process.env.NODE_ENV === 'development' ? "http://localhost:49895/hydrogen" : "https://wigwam-shopify-event-5lszmmt3ka-de.a.run.app/hydrogen"

const shared = axios.create()
shared.defaults.headers.common['ES-Access-Token'] = "k3YW8WF2JGTi8v6EqrnO+w==";

const ticket = (() => {
  const activate_path = prefix + '/tickets/activate'
  const list_path = prefix + '/tickets'
  return {
    activate(id, options={}) {
      return shared.post(`${activate_path}/${id}`, {}, options);
    },
    get(phone) {
      if (!phone) throw new Error("phone is required");
      return axios.get(`${list_path}?phone=${phone}`);
    },
  }
})();

let invitation = (() => {
  const activate_path = prefix + '/activate'
  const deactivate_path = prefix + '/deactivate'
  const list_path = prefix + '/invitation'
  return {
    activate(uuid, options={}) {
      return shared.post(activate_path, {'uuid': uuid}, options)
    },
    deactivate(uuid, options={}) {
      return shared.post(deactivate_path, {'uuid': uuid}, options)
    },
    get(p=null) {
      if (p) return axios.get(p)
      return axios.get(list_path)
    },
  }
})()

let token = (() => {
  const path = prefix + '/token'
  let loggedIn = false
  //const refresh_path = prefix + '/token/refresh'
  return {
    set(t) {
      shared.defaults.headers.common['Authorization'] = `JWT ${t}`
      loggedIn = t ? true : false
    },
    get(username, password) {
      return shared.post(path, {'username': username, 'password': password})
    },
    loggedIn,
  }
})()

export default {
  ticket,
  invitation,
  token
}
export { invitation, token, ticket }
